import { Box, styled, Typography } from '@mui/material';
import { blue } from 'themes/colors';

export const StyledTitle = styled(Typography)`
  font-size: 40px;
  line-height: 1;
  font-weight: 700;
  color: ${blue[400]};
`;

export const StyledBox = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const StyledDetailsHolder = styled(Box)`
  align-self: flex-end;
`;
